export default "__VITE_ASSET__Dup3BbCx__"